import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TripService } from '../../../services/trip.service';
import { ContentContainerComponent } from '../../ui/content-container/content-container.component';
import { PanelBodyComponent } from '../../ui/panel-body/panel-body.component';
import { TripLinkQrComponent } from '../../trip-link-qr/trip-link-qr.component';

@Component({
  selector: 'app-trip-qr-panel',
  imports: [ContentContainerComponent, PanelBodyComponent, TripLinkQrComponent],
  templateUrl: './trip-qr-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TripQrPanelComponent {
  private readonly tripService = inject(TripService);

  readonly tripId = this.tripService.currentTripId;
}
